import './App.css';
import {AppMain} from "./App/AppMain";

function App() {
  return (
      <>
          <div className="App">
              <header className="App-header">
                  <AppMain/>

              </header>
          </div>
      </>
  );

}

export default App;
